{
    "ModalTitleAdd": "Adicionar novo relatório",
    "ModalTitleModify": "Modificar relatório",
    "ModalTitleDateTime": "Intervalo de data\/hora",
    "TabnameReport": "Relatório",
    "TabnameFilter": "Filtro",
    "TabnameOther": "Outro",
    "TabnameFields": "Campos",
    "TabnameDashboard": "Esquema",
    "TabnameSlakpi": "SLA\/KPI",
    "TabnameAlarms": "Alarmes",
    "TabnameScheduling": "Agendamento",
    "TabnameAcdCodes": "Códigos",
    "TabnameFinancial": "Financeiro",
    "TabnameSettings": "Definições",
    "TabnamePrint": "Imprimir",
    "TabnameAdvanced": "Avançado",
    "ReporttypelabelNolistitems": "Nenhum item de lista atual com esse nome.",
    "ConfigureReport_ButtonHelpLabel": "Ajuda?",
    "ConfigureReport_ButtonSubmitLabel": "OK",
    "ConfigureReport_ButtonCancelLabel": "Cancelar",
    "ConfigureReport_PromptMessage": "Tem certeza de que deseja fechar esta janela? TTodas as configurações modificadas serão perdidas ao fechá-la.",
    "ConfigureReport_PromptConfirm": "sim",
    "ConfigureReport_PromptCancel": "Cancelar",
    "ConfigureReport_Basic": "Básico",
    "ConfigureReport_Advanced": "Avançado",
    "NAME": "ConfigureReport"
}